import React, { useState } from "react";
import styles from "./styles/styles.module.scss";
import ServiceCard from "./ServiceCard";
import { Container, Row, Button } from "react-bootstrap";
import { FormattedMessage } from "react-intl";

const Index = ({ data }) => {
  const { servicesData } = data;

  const [visibleServices, setVisibleServices] = useState(8);

  const renderServices = () => {
    if (servicesData?.services?.length > 0) {
      return servicesData?.services
        .slice(0, visibleServices)
        .map((item, index) => (
          <ServiceCard service={item} key={index} index={index} />
        ));
    }
    return null;
  };

  const showMoreServices = () => {
    setVisibleServices((prev) => prev + 8);
  };

  return (
    <div className={styles.blogs}>
      <Container>
        <Row>{renderServices()}</Row>
        {visibleServices < servicesData?.services?.length && (
          <div className="view-all">
            <Button className="nav-link" onClick={showMoreServices}>
              <FormattedMessage id="show-more" />
            </Button>
          </div>
        )}
      </Container>
    </div>
  );
};

export default Index;
